
jQuery(document).ready(function ($) {

    $('.wp-block-custom-blocks-tabs .tabs a').on('click', function(e) {

        e.preventDefault();
        var href = $(this).attr('href');
        var parent = $(this).closest('.wp-block-custom-blocks-tabs');

        parent.find('.tabs-item').each(function() {
            $(this).removeClass('active');
            $(this).css('display', 'none');               
        });

        parent.find('.tabs a').each(function() {
            $(this).removeClass('active');            
        });

        $(parent).find('.tabs-item '+ href).parent().addClass('active');
        $(parent).find('.tabs-item '+ href).parent().css('display', 'block'); 

        $(this).addClass('active');
        
    });


    // von maja geklaut :D
    $('.wp-block-custom-blocks-tabs').each(function () {

        $tabblock = $(this);
        $tabscontainer = $(this).find('.tabs__container');
        $tabs = $tabscontainer.find('.tabs');
        $tablink = $(this).find('.tabs a');

        // Move tabs to wrapper      
        $(this).find('.tabs a').detach().prependTo($(this).find('.tabs'));
        $(this).find('.tabs a').first().addClass('active');

        // Show navigation if tabs are larger than wrapper
        show_tab_navigation($(this));

        // Scroll Navigation
        $(this).find('.is--right').on('click', function () {
            $tabs.animate({ scrollLeft: '+=200' }, 500);
        })
        $(this).find('.is--left').on('click', function () {
            $tabs.animate({ scrollLeft: '-=200' }, 500);
        })

        // Change tab on click
        $tablink.on('click', function () {
            var index = $(this).index();
            $tabblock.find('.tablink').removeClass('active');
            $(this).addClass('active');
            $tabblock.find('.tabitem').hide();
            $tabblock.find('.tabitem').eq(index).fadeIn();
        })

    })

    // show navigation
    function show_tab_navigation(elem) {
        var blockWidth = elem.outerWidth();
        var totalWidth = 0;
        elem.find('.tabs a').each(function (index) {
            totalWidth += parseInt($(this).outerWidth(), 10);
        });
        if (blockWidth < totalWidth) {
            $tabscontainer.addClass('is--cut');
        } else {
            $tabscontainer.removeClass('is--cut');
        }
    }

    // Change tab by window.location.hash
    if (window.location.hash) {

        $tablink = $('a[href="'+ window.location.hash +'"]')

        if($tablink.parent(".tabs").length) {
            $tablink.trigger('click');

            // smooth scroll to the anchor id
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top - 120 + 'px'
            }, 500, 'swing');
        }
    }

    // Change tab by link with hash
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            if ($(this.hash).hasClass('tablink')) {
                $tablink = $(this.hash);
                $tablink.trigger('click');
            }
        })

    // Check for navigation on window resize
    $(window).on('resize scroll', function () {
        $('.wp-block-custom-blocks-tabs').each(function () {
            show_tab_navigation($(this));
        })

    });

});


// WEBPACK FOOTER //
// ./src/blocks/tabs/js/script.js